import { render, staticRenderFns } from "./DefaultHeaderDropdownAccnt.vue?vue&type=template&id=a3cfacd8&"
import script from "./DefaultHeaderDropdownAccnt.vue?vue&type=script&lang=ts&"
export * from "./DefaultHeaderDropdownAccnt.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultHeaderDropdownAccnt.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports